import { render, staticRenderFns } from "./ProjectStatisticsXmsl.vue?vue&type=template&id=627568e2&scoped=true&"
import script from "./ProjectStatisticsXmsl.vue?vue&type=script&lang=js&"
export * from "./ProjectStatisticsXmsl.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatisticsXmsl.vue?vue&type=style&index=0&id=627568e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627568e2",
  null
  
)

export default component.exports